package com.volkswagen.vocs.grip.vocstis

import kotlin.Double
import kotlin.String
import kotlin.collections.Map
import kotlinx.datetime.LocalDate
import kotlinx.serialization.Serializable

@Serializable
public data class ArticleResponse(
  public val article: String,
  public val description: String? = null,
  public val description2: String? = null,
  public val articleAlias: String? = null,
  public val quantity: Double? = null,
  public val quantityUom: QuantityUom? = null,
  public val weight: Double? = null,
  public val weightUom: WeightUom? = null,
  public val validFrom: LocalDate? = null,
  public val validTo: LocalDate? = null,
  public val tariffNumber: String,
  public val tariffKind: TariffKind,
  public val tariffRegion: TariffRegion,
  public val translations: Map<String, String>,
)
